import axios from "axios";

const AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // API Gateway base URL
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*', // Note: This is not used by browsers; server must return this
        'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        'client_id': process.env.REACT_APP_MULESOFT_API_CLIENT_ID || '',
        'client_secret': process.env.REACT_APP_MULESOFT_API_CLIENT_SECRET || '',
    }
});

export default AxiosInstance;